import React, { useContext } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  Slide,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import CloseIcon from '@material-ui/icons/Close'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import { useStyles } from './Styles'
import { OTPCaptchaContext } from '../../../../OTPCaptcha'
import { ButtonLoader } from '../../../Loader/ButtonLoader'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ChangeEmail ({ additionalInfoForm, resetEmailStatus, onEmailVerified }) {
  const classes = useStyles()
  const intl = useIntl()
  const { generateCaptcha, captchaData, captchaDataLoading, captchaDataFailure } = useContext(OTPCaptchaContext)

  const [open, setOpen] = React.useState(false)
  const [newEmail, setNewEmail] = React.useState('')
  const [captchaGuess, setCaptchaGuess] = React.useState('')

  const handleClickOpen = () => {
    reGenerateCaptcha()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setNewEmail('')
    setCaptchaGuess('')
    if (!!resetEmailStatus) {
      resetEmailStatus()
    }
  }

  const reGenerateCaptcha = () => {
    if (!!generateCaptcha) {
      generateCaptcha()
    }
    setCaptchaGuess('')
  }

  const handleCaptchaGuessChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setCaptchaGuess(event.target.value)
  }

  return (
    <AuthenticatedUserConsumer>
      {({ handleChangeEmail, verifyNewEmail, verifyNewEmailSuccess, confirmNewEmailSuccess, verifyNewEmailLoading, verifyNewEmailFailure, verifyNewEmailFailureMessage }) => (
        <div>
          <button type='button' className={classes.changePhoneButton} onClick={handleClickOpen}>
            <FormattedMessage id='ChangeEmail.button'/>
          </button>
          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            classes={{ paper: classes.ChangePhoneDialogPaper }}
            onClose={handleClose}
            aria-labelledby="ChangeEmail-title"
            aria-describedby="ChangeEmail-description"
          >
            <DialogTitle id="ChangeEmail-title" disableTypography className={classes.ChangePhoneDialogHeader}>
              <Typography variant="h5"><FormattedMessage id='ChangeEmail.DialogTitle'/></Typography>
              <IconButton
                edge={false}
                className={classes.ChangePhoneDialogClose}
                color="inherit"
                aria-label="close dialog"
                onClick={handleClose}
              >
                <CloseIcon/>
              </IconButton>
            </DialogTitle>
            <DialogContent className={classes.ChangePhoneDialogContent}>
              <Box p={4}>
                {!!verifyNewEmailLoading && <FormLoader loading={true}/>}
                {!!verifyNewEmailFailure && !!verifyNewEmailFailureMessage &&
                <Alert severity="error">{verifyNewEmailFailureMessage}</Alert>
                }
                {!!confirmNewEmailSuccess &&
                <Alert severity="success"><FormattedMessage id='ChangeEmail.FormSuccessAlert'/></Alert>
                }
                {!!captchaDataFailure &&
                <Alert severity="error"><FormattedMessage id='captcha.generateErrorAlert'/></Alert>
                }
                {!!verifyNewEmailSuccess ?
                  <div className={classes.ChangePhoneVerifyWrapper}>
                    <p align={'center'}><strong><FormattedMessage id='ChangeEmail.VerificationCode.message'/></strong></p>
                    <div className={classes.ChangePhoneVerify}>
                      <InputLabel id="ChangeEmail.VerificationCode"><FormattedMessage
                        id='Fields.label.VerificationCode'/></InputLabel>
                      <FormControl variant="outlined">
                        <TextField
                          fullWidth
                          placeholder={intl.formatMessage({ id: 'AdditionalInfo.placeholder.VerificationCode' })}
                          id="ChangeEmail.VerificationCode"
                          type='text'
                          margin="dense"
                          variant="outlined"
                          name='VerificationEmailCode'
                          onChange={additionalInfoForm.handleChange}
                          onBlur={additionalInfoForm.handleBlur}
                          value={additionalInfoForm.values.VerificationEmailCode}
                        />
                      </FormControl>
                    </div>
                    <Button variant={'contained'} onClick={() => {
                      handleChangeEmail(additionalInfoForm.values.VerificationEmailCode, additionalInfoForm, handleClose, onEmailVerified)
                    }} color="primary">
                      <FormattedMessage id='ChangePhone.DialogActions.verify'/>
                    </Button>
                  </div>
                  :
                  <div className={classes.ChangePhoneVerifyWrapper}>
                    <div className={classes.ChangePhoneVerify}>
                      <InputLabel id="ChangeEmail.newEmail">
                        <FormattedMessage id='ChangeEmail.label.newEmail'/>
                      </InputLabel>
                      <FormControl variant="outlined" fullWidth>
                        <TextField
                          fullWidth
                          placeholder={intl.formatMessage({ id: 'ChangeEmail.placeholder.newEmail' })}
                          id="ChangeEmail.newEmail"
                          type='email'
                          margin="dense"
                          variant="outlined"
                          name='newEmail'
                          autoFocus
                          value={newEmail}
                          onChange={(e) => setNewEmail(e.target.value)}
                        />
                      </FormControl>
                    </div>
                    <div className={classes.captchaWrapper}>
                      <div className={classes.captchaRow}>
                        <div className={classes.captchaContainer + (!!captchaDataLoading ? ' loading' : '')}>
                          {!!captchaDataLoading && <ButtonLoader loading={true} size={50}/>}
                          {!!captchaData?.img &&
                          <img src={captchaData?.img} alt={'Captcha'}/>}
                        </div>
                        <Tooltip title={intl.formatMessage({ id: 'captcha.regenerate' })}>
                          <IconButton color="primary" aria-label={intl.formatMessage({ id: 'captcha.regenerate' })}
                                      onClick={reGenerateCaptcha} className={classes.captchaGenerateBtn}>
                            <AutorenewIcon/>
                          </IconButton>
                        </Tooltip>
                      </div>
                      <div className={classes.AdditionalInfoRow}>
                        <InputLabel id="ChangeEmail.CaptchaCode"><FormattedMessage
                          id='Fields.label.CaptchaCode'/></InputLabel>
                        <FormControl variant="outlined">
                          <TextField
                            fullWidth
                            placeholder={intl.formatMessage({ id: 'Fields.Placeholder.CaptchaCode' })}
                            id="ChangeEmail.CaptchaCode"
                            type='text'
                            margin="dense"
                            variant="outlined"
                            name='CaptchaCode'
                            onChange={handleCaptchaGuessChange}
                            value={captchaGuess}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <Button variant={'contained'}
                            disabled={!newEmail || !newEmail.includes('@') || !captchaGuess.length || captchaGuess.length !== 6}
                            onClick={() => verifyNewEmail(newEmail, captchaData?.key, captchaGuess, reGenerateCaptcha)}
                            color="primary">
                      <FormattedMessage id='ChangePhone.DialogActions.verify'/>
                    </Button>
                  </div>
                }
              </Box>
            </DialogContent>
            <DialogActions className={classes.ChangePhoneDialogFooter}>
              <Button onClick={handleClose} color="primary">
                <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </AuthenticatedUserConsumer>
  )
}
